<template>
 <div class='formPage'>
     <div class="evaluationNot-header">
         <span @click="back" class="black_arrow">
            <svg-icon icon-class="arrow-icon" class-name="arrow-icon"></svg-icon>
        </span>
            填写表单
    </div>
    <div class="portrait">
        <img :src="headImage" alt="">
        <span>{{user.name}}</span>
    </div>
    <div class="hello">
      <question :themeColor="themeColor" :buttomText="buttomText" :imgUrl="imgUrl" :type="type" :typeId="typeId" ></question>
    </div>
 </div>
</template>

<script>
export default {
    name:'formPage',
    data () {
        return {
            themeColor:'#1972FF',
            buttomText:'提交',
            type:this.$route.query.type,
            typeId: this.$route.query.typeId,
            imgUrl: 'https://wd-appdownload.oss-cn-beijing.aliyuncs.com/c-h5-fe/h5FormHeader.png',
            headImage: '',
            user: {},
        };
    },
    components: {
    },
    filters: {
    },
    watch:{
    },
    methods: {
        back(){
            if(this.$isapp){
                this.$WDJSBridge.useBack()
            }else{
                this.$router.go(-1);
            }
        },
        // 我的资料
        getPersonalInfo(){
            this.$api.user.findUser().then(res => {
                if(res.code == 0){
                    this.user = res.data;
                    if (this.user.headImage) {
                        this.headImage = this.user.headImage;
                    } else {
                        this.headImage = require("../../../assets/images/learning/userL.png");
                    }
                }
            })
        },
    },
    destroyed() {
    },
    mounted() {
    },
    created(){
        this.getPersonalInfo();
    },
}

</script>
<style scoped lang='less'>
.formPage {
    .evaluationNot-header {
        height: 88px;
        line-height: 88px;
        text-align: center;
        font-size: 36px;
        font-weight: 500;
        color: #333333;
        border-bottom: 1px solid #EBEDF2;
        position: relative;
        .black_arrow{
            position: absolute;
            left: 32px;
            top: 0px;
            .arrow-icon{
                font-size: 32px;
                font-weight: 500;
            }
        }
    }
    .portrait {
        height: 100px;
        line-height: 100px;
        margin: 24px;
    }
    .portrait img {
        height: 100px;
        margin-right: 14px;
        border-radius: 50%;
    }
    .portrait span {
        font-size: 32px;
        font-family: AlibabaPuHuiTiR;
        color: #333333;
    }
}
</style>
